import { Action } from '@ngrx/store';

export enum GuardActionTypes {
  SET_ESTABLISMENT_ID = '[Guard Actions] Set Establisment id',

  OPEN_SETTINGS_PAGE = '[Guard Actions] Open settings page',
  CLOSE_SETTINGS_PAGE = '[Guard Actions] Close settings page',

  BYPASS_ESTABLISHMENT_VERIFICATION = '[Guard Actions] Bypass establishment verification',
}

export class OpenSettingsPage implements Action {
  readonly type = GuardActionTypes.OPEN_SETTINGS_PAGE;
}

export class CloseSettingsPage implements Action {
  readonly type = GuardActionTypes.CLOSE_SETTINGS_PAGE;
}

export class SetEstablismentId implements Action {
  readonly type = GuardActionTypes.SET_ESTABLISMENT_ID;
  constructor(public payload?: { establishmentId: string }) {}
}

export class BypassEstablishmentVerification implements Action {
  readonly type = GuardActionTypes.BYPASS_ESTABLISHMENT_VERIFICATION;
}

export type GuardActions = OpenSettingsPage | CloseSettingsPage | SetEstablismentId | BypassEstablishmentVerification;
